import { type ReactElement, useMemo } from "react";
import { Typography } from "../../abstract/Typography/Typography";
import { TypographyProps } from "../../abstract/Typography/Typography.types.ts";
import { compiler } from "markdown-to-jsx";

export type AllowedHeadingElement =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "span";

export type A1HeadingProps = TypographyProps<AllowedHeadingElement>;

export function A1Heading({
  children,
  className,
  variant = "heading-2",
  ...restProps
}: A1HeadingProps): ReactElement {
  const transformerText = useMemo(
    () =>
      typeof children === "string"
        ? compiler(children, { forceInline: true, wrapper: null })
        : children,
    [children],
  );
  return (
    <Typography className={className} variant={variant} {...restProps}>
      {transformerText}
    </Typography>
  );
}
